import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EventDetail = () => {
  const { t, i18n } = useTranslation();
  const { eventId } = useParams();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";

  const [event, setEvent] = useState(null);
  const [showOtpScreen, setShowOtpScreen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      FullName: document.getElementById("regName").value,
      Email: document.getElementById("regEmail").value,
      Mobile: document.getElementById("regPhone").value,
      JobTitle: document.getElementById("regJobTitle").value || null,
      OrganizationName:
        document.getElementById("regOrganization").value || null,
    };

    try {
      const response = await axiosInstance.post(
        `/api/v1/users/events/${eventId}/register`,
        formData
      );

      if (response.status === 200) {
        toast.success(t("registration.success"));
        setShowOtpScreen(true);
      }
    } catch (error) {
      const errorData =
        error.response?.data ?? (error.title ? error : null) ?? {};
      toast.error(errorData.detail || errorData.title);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    AOS.init();
    axiosInstance
      .get(`/api/v1/users/events/${eventId}`)
      .then((response) => setEvent(response.data))
      .catch((err) => console.error(err));
  }, [eventId]);

  if (!event) return <div className="text-center my-5">{t("loading")}...</div>;

  const location = event.isOnline
    ? t("events_online")
    : event.city?.arabicName || t("events_no_location");


 const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return "";

  const dateObj = new Date(dateTimeString);
  const date = dateObj.toLocaleDateString("ar-EG"); 
  const time = dateObj.toLocaleTimeString("ar-EG", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return `${date} ${time}`;
};



  return (
    <section className="py-5" dir={languageDirection}>
      <div className="container">
        <div className="mb-4">
          <a href="/events" className="btn btn-outline-secondary">
            <i className="fas fa-arrow-right me-2"></i> {t("back_to_events")}
          </a>
        </div>

        <div className="row mb-4">
          <div className="col-md-8">
            <h1 className="section-title">
              {i18n.language === "ar" ? event.arabicName : event.englishName}
            </h1>{" "}
            <div className="d-flex flex-wrap align-items-center mb-3">
              {/* التاريخ */}
              <div className="d-flex align-items-center gap-2 mb-3">
                <i className="fas fa-calendar-alt text-primary-custom fs-5"></i>
                <span className="text-secondary fw-bold">{t("from")}:</span>
                <span className="text-dark">
                  {event.eventOn}
              </span>
                <span className="mx-2 text-muted">|</span>
                <span className="text-secondary fw-bold">{t("to")}:</span>
                <span className="text-dark">
                  {event.eventEndOn}
                </span>
              </div>

              {/* مكان الفعالية */}
              <div className="me-4 mb-2">
                <p className="card-text text-muted d-flex align-items-center">
                  <i
                    className={`fas ${
                      event.isOnline
                        ? "fa-video text-success"
                        : "fa-map-marker-alt text-primary"
                    } me-2`}
                  ></i>
                  <span
                    className={`badge px-2 py-1 rounded ${
                      event.isOnline
                        ? "bg-success-subtle text-success"
                        : "bg-primary-subtle text-primary"
                    }`}
                  >
                    {location}
                  </span>
                </p>
              </div>

              {/* عدد الحضور */}
              {/* <div className="me-4 mb-2">
                <i className="fas fa-users text-primary-custom me-2"></i>
                {t("expected_attendance")}: {event.expectedAttendance}+
              </div> */}
            </div>
            <div>
              <span className="badge bg-success mb-3">
                {t(event.status === "upcoming" ? "upcoming" : event.status)}
              </span>
              {event?.specialities?.map((topic, index) => (
                <span
                  key={index}
                  className="badge rounded-pill bg-light text-dark me-2 mb-2 p-2"
                >
                  <i className="fas fa-microchip me-1"></i> {topic.name}
                </span>
              ))}
            </div>
          </div>
          <div className="col-md-4 text-md-end">
            <a href="#register-section" className="btn btn-primary mb-2">
              <i className="fas fa-ticket-alt me-2"></i>{" "}
              {t("register_for_event")}
            </a>
            {/* <button className="btn btn-outline-primary-custom ms-2 mb-2">
              <i className="fas fa-share-alt me-2"></i> {t("share")}
            </button> */}
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-lg-8">
            <div className="card shadow-sm mb-4">
              <div className="card-img-top position-relative">
                <img
                  src={event.bannerUrl}
                  className="img-fluid w-100"
                  alt="صورة الفعالية"
                  style={{ maxHeight: "300px", objectFit: "cover" }}
                />
              </div>
              <div className="card-body">
                <h5 className="card-title">{t("about_event")}</h5>
                <p>
                  {i18n.language === "ar"
                    ? event.arabicDetails
                    : event.englishDetails}
                </p>
                <h5 className="card-title mt-4">{t("event_topics")}</h5>
                <div className="d-flex flex-wrap mb-3">
                  {event?.eventSpecialities?.map((topic, index) => (
                    <span
                      key={index}
                      className="badge rounded-pill bg-light text-dark me-2 mb-2 p-2"
                    >
                      <i className="fas fa-microchip me-1"></i>{" "}
                      {i18n.language === "ar"
                        ? topic.arabicName
                        : topic.englishName}
                    </span>
                  ))}
                </div>

                <div className="card mt-4">
                  <div className="card-body bg-light">
                    <h6 className="card-title mb-3">{t("event_details")}</h6>
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="list-unstyled">
                          <li className="mb-2">
                            <i className="fas fa-building text-primary-custom me-2"></i>
                            <strong>{t("venue")}</strong>{" "}
                            <p className="card-text text-muted d-flex align-items-center">
                              <i
                                className={`fas ${
                                  event.isOnline
                                    ? "fa-video text-success"
                                    : "fa-map-marker-alt text-primary"
                                } me-2`}
                              ></i>
                              {event.isOnline ? (
                                <span className="badge bg-success-subtle text-success px-2 py-1 rounded">
                                  {t("events_online")}
                                </span>
                              ) : (
                                <span className="badge bg-primary-subtle text-primary px-2 py-1 rounded">
                                  {location}
                                </span>
                              )}
                            </p>
                          </li>

                          <li className="mb-2">
                            <i className="fas fa-clock text-primary-custom me-2"></i>
                            <strong>{t("time")}</strong>
                            <br />
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <i className="fas fa-calendar-alt text-primary-custom fs-5"></i>
                              <span className="text-secondary fw-bold">
                                {t("from")}:
                              </span>
                              <span className="text-dark">
                                {event.eventOn}
                            </span>
                              <span className="mx-2 text-muted">|</span>
                              <span className="text-secondary fw-bold">
                                {t("to")}:
                              </span>
                              <span className="text-dark">
                                {event.eventEndOn}
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {!event.isOnline &&
                        event.isExternalEvent &&
                        event.link && (
                          <div className="col-md-6">
                            <ul className="list-unstyled">
                              <li className="mb-2">
                                <i className="fas fa-globe text-primary-custom me-2"></i>
                                <strong>{t("website")}:</strong>{" "}
                                <a
                                  href={event.link}
                                  className="text-primary-custom"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {t("click_here")}
                                </a>
                              </li>
                            </ul>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="card shadow-sm mb-4">
              <div className="card-body">
                <h5 className="card-title">{t("event_schedule")}</h5>
                <div id="scheduleContent" className="border-top pt-3 mt-2">
                  <div className="text-center text-muted py-3">
                    {t("no_schedule_published")}
                  </div>
                </div>
              </div>
            </div>

            <div className="card shadow-sm mb-4" id="register-section">
              <div className="card-body">
                <h5 className="card-title">{t("register_now")}</h5>
                {/* <p className="text-muted mb-3">{t("register_description")}</p> */}
                <div className="text-center text-muted py-3">
                  {/* {t("registration_soon")} */}
                </div>
                {/* فورم التسجيل */}
                <form id="eventRegistrationForm" onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="regName" className="form-label">
                      {t("full_name")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="regName"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="regEmail" className="form-label">
                      {t("email")}
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="regEmail"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="regPhone" className="form-label">
                      {t("phone")}
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="regPhone"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="regJobTitle" className="form-label">
                      {t("job_title")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="regJobTitle"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="regOrganization" className="form-label">
                      {t("organization")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="regOrganization"
                    />
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary">
                      <i className="fas fa-check-circle me-2"></i>{" "}
                      {t("confirm_registration")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default EventDetail;
